import { reaction } from 'mobx';
import type EditingStateManager from '@src/slide/application/service/editing-state-manager';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IMobileEditorAppServices } from '@src/slide/application/entry/toc/editor/mobile/mobile-editor-app-service.interface';

export default class CanvasMobileMenuManager {
    public static instance: CanvasMobileMenuManager;
    public static getInstance(): CanvasMobileMenuManager {
        if (!CanvasMobileMenuManager.instance) {
            CanvasMobileMenuManager.instance = new CanvasMobileMenuManager();
        }
        return CanvasMobileMenuManager.instance;
    }

    private editingStateManager: EditingStateManager;

    public init = (editingStateManager: EditingStateManager): void => {
        this.editingStateManager = editingStateManager;
        this.registerListener();
    };

    private registerListener = (): void => {
        reaction(
            () => (this.checkStateChange()),
            () => {
                this.handleElementStateChange();
            },
        );
    };

    private handleElementStateChange = () => {
        (AppServiceProvider.getInstance().getAppServices() as IMobileEditorAppServices).viewableServiceLayer
            .mobileRightMenuMananger.promise().then((mobileRightMenuMananger) => {
                mobileRightMenuMananger.hideMenu();
            });
    };

    private checkStateChange = () => this.editingStateManager.isControlValuesChanging
        || this.editingStateManager.isDragging || this.editingStateManager.isResizing
        || this.editingStateManager.isRotating;
}
